
import { MaterialReactTable, MRT_ToggleFiltersButton, MRT_ToggleGlobalFilterButton, useMaterialReactTable } from "material-react-table";
import { CER_WCN_LISTING_TABLE_COLUMNS } from "./CERlistingTablecolumn";
import React, { useEffect, useState, useMemo } from "react";
import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { Button, COLORS, Modal, Icon, ICONS, AbsDropDown } from "abs-ui-components";
import { useSelector } from "react-redux";
import { Autocomplete, Checkbox, Chip, TextField } from "@mui/material";
import axiosHttp from "../../../services/interceptor";
import { accessAPIForResponse } from "../../../services/api-services/api-implementations";
import { useParams } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import "./CERPopup.css";
import DeleteIcon from "@mui/icons-material/Delete";
import AbsModal from "../../../common/absModal/AbsModal";
import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import { emitToasterMsg } from "../../../services/toasterUtility";
import { assignReviewer, claimReport, deleteReport, downloadAllReportDocuments, getDeleteState, unclaimReport } from "../CERHelpers";
import { useSearchParams } from "react-router-dom";
import { CustomTableRow } from "../../SignInModule/UserAutherization/utilities";

export const HighlightedCell = ({
    value,
    columnId,
    reportListColumnFilters,
    user,
}) => {

    const currentFilter =
        reportListColumnFilters.find(
            (f) => f.id === columnId
        );

    const selectedValues =
        currentFilter?.value || [];

    const normalizedSelectedValues = selectedValues.map((item) => {

        if (item === "@Me") {
            return user?.email;
        }

        if (item === "@Unassigned") {
            return "";
        }

        return item;
    });

    const isMatched =
        Array.isArray(normalizedSelectedValues) &&
        normalizedSelectedValues.includes(value);

    return (
        <span
            style={{
                backgroundColor: isMatched
                    ? "rgb(255, 203, 127)"
                    : "transparent",
                color: isMatched
                    ? "black"
                    : "inherit",
                padding: "2px 4px",
                borderRadius: "4px",
            }}
        >
            {value}
        </span>
    );
};

export const MultiSelectFilter = React.memo(({
    columnId,
    options,
    placeholder,
    columnWidth,
    getFilterValue,
    updateFilterValue,
}) => {

    return (
        <Autocomplete
            multiple
            options={options}
            disableCloseOnSelect
            value={getFilterValue(columnId) || []}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(e, newValue) => {
                updateFilterValue(columnId, newValue);
            }}
            size="small"

            renderOption={(props, option, { selected }) => (
                <li {...props} key={option}>
                    <Checkbox checked={selected} />
                    {option}
                </li>
            )}

            renderTags={(value, getTagProps) =>
                <Chip
                    label={value.length > 1 ? `${value.length} ${columnId}s selected` : value[0]}
                    size="small"
                    sx={{
                        backgroundColor: "gray",
                        color: "white",

                        "& .MuiChip-deleteIcon": {
                            color: "white",
                        },
                    }}
                />
            }

            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    placeholder={placeholder}
                />
            )}

            sx={{
                width: columnWidth || "auto",

                "& .MuiInputBase-input": {
                    color: "white",
                },

                "& .MuiSvgIcon-root": {
                    color: "white",
                },

                "& .MuiInput-underline:before": {
                    borderBottomColor: "white",
                },

                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "white",
                },

                "& .MuiInput-underline:after": {
                    borderBottomColor: "white",
                },
            }}
        />
    );
});

export const CERlisting = () => {
    const [searchParams] = useSearchParams();
     const [wcnNumber, setWcnNumber] = useState("");
     const [companyName, setCompanyName] = useState("");
    const wcnMstId = searchParams.get("wcnMstId");
    const companyImoNumber = searchParams.get("companyImoNumber");
    const baseURL = process.env.REACT_APP_BASE_URL;
    const user = useSelector((state) => state.userInfo.userData);
    const [tableData, setTableData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25,
    });
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    const [sorting, setSorting] = useState([]);
    const [pendingColumnFilters, setPendingColumnFilters] = useState([]);
    const [pendingGlobalFilter, setPendingGlobalFilter] = useState("");
    const [appliedGlobalFilter, setAppliedGlobalFilter] = useState("");
    const [engineersOptions, setEngineersOptions] = useState([]);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [selectedEngineer, setSelectedEngineer] = useState("");
    const [selectedReportId, setSelectedReportId] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const getAllEngineers = async (input) => {
        try {
            const response = await accessAPIForResponse(
                "GetReviewEngineers",
                null,
                [input]
            );

            if (response) {
                const emails = response.map(
                    (engineer) => engineer.emailAddress
                );
                setEngineersOptions(emails);

                return emails.map((email) => ({
                    label: email,
                    value: email,
                }));
            }

            setEngineersOptions([]);
            return [];
        } catch (error) {
            console.error("Error fetching engineers:", error);
            setEngineersOptions([]);
            return [];
        }
    };

    const breadcrumb = useMemo(
        () => [
            {
                label: "Annual Emission Verification",
                url: "/eumrv-company-emission-verification-report",
                navId: "annual_emission_verification_navid",
            },
            {
                label: "EU MRV Company Emission  Reports",
                url: "/eumrv-company-emission-verification-report",
                navId: "company_emission_verification_reports_navid",
            },
            {
                label: "Company Verification Report",
                url: "",
                navId: "company_verification_report_navid",
            },
        ],
        []
    );

    const getCerWcnData = async () => {
        try {
            setLoading(true);
            const payload = {
                globalFilter: appliedGlobalFilter,
                filters: [
                    ...columnFilters.map((filter) => ({
                        key: filter.id,
                        value: Array.isArray(filter.value)
                            ? filter.value.map((item) => {
                                if (item === "@Me") {
                                    return user?.email;
                                }

                                if (item === "@Unassigned") {
                                    return "";
                                }

                                return item;
                            })
                            : filter.value,
                    })),
                    {
                        key: "wcnMstId",
                        value: wcnMstId,
                    },
                    {
                        key: "companyImoNumber",
                        value: companyImoNumber,
                    },
                ],
                pagination: {
                    page: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                },
                sortOption: {
                    sortField: sorting?.[0]?.id ?? "",
                    isAscending: !sorting?.[0]?.desc,
                },
                reportYear: 2026,
            };
            const response = await axiosHttp.post(
                `${baseURL}api/CompanyVerification/GetWcnCerGrid?fromWcnCerPage=false`,
                payload
            );

            setTableData(response?.data?.data ?? []);
             const data = response?.data?.data ?? [];
            if (data.length > 0) {
                setWcnNumber(data[0].wcnNumber); 
                setCompanyName(data[0].companyName);
            }
            setRowCount(
                response?.data?.pagination?.totalItems ?? 0
            );
        } catch (error) {
            console.error("Failed to fetch CER WCN data", error);
        }finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        getCerWcnData();
    }, [pagination, columnFilters, sorting, appliedGlobalFilter]);

    const applyFilters = () => {
        const cleanedFilters = pendingColumnFilters.filter(
            (filter) => filter.value?.toString().trim() !== ""
        );
        setColumnFilters(cleanedFilters);
        setAppliedGlobalFilter(pendingGlobalFilter?.trim() || "");

        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
        setPendingColumnFilters(cleanedFilters);
    };

    const clearFilters = () => {
        setPendingColumnFilters([]);
        setColumnFilters([]);
        setPendingGlobalFilter("");
        setGlobalFilter(""); // Reset the input
        setAppliedGlobalFilter("");
        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
    };

    useEffect(() => {
        if (!pendingGlobalFilter && appliedGlobalFilter !== "") {
            setAppliedGlobalFilter("");
            setPagination((prev) => ({
                ...prev,
                pageIndex: 0,
            }));
        }
    }, [pendingGlobalFilter, appliedGlobalFilter]);

    const getFilterValue = (columnId) =>
        pendingColumnFilters.find((f) => f.id === columnId)?.value || [];

    const updateFilterValue = (columnId, value) => {
        setPendingColumnFilters((prev) => {
            const others = prev.filter((f) => f.id !== columnId);

            if (!value?.length) {
                return others;
            }

            return [...others, { id: columnId, value }];
        });
    };

    useEffect(() => {
        getAllEngineers("");
    }, []);

    const handleAssignClick = (row) => {
        setSelectedReportId(row.original.companyVerificationReportId);
        setSelectedEngineer(
            row.original.reviewer ||
            row.original.verifier ||
            ""
        );

        setShowAssignModal(true);
    };

    const handleAssign = async () => {
        try {
            await assignReviewer(
                selectedReportId,
                selectedEngineer
            );

            emitToasterMsg("success", "CER Report", "Assigned Successfully"
            );

            setShowAssignModal(false);
            getCerWcnData();
        } catch (error) {
            emitToasterMsg("error", "CER Report", "Assignment failed"
            );
        }
    }

    const handleSelect = (selected) => {
        if (!selected) {
            setSelectedEngineer(null); 
            return;
        }

        setSelectedEngineer(
            selected.value || selected.email || selected
        );
    };

    const toggleClose = () => {
        setShowAssignModal(false);
    };

    const handleClaim = async (row) => {
        try {
            await claimReport(
                baseURL,
                row.original.companyVerificationReportId,
                user.email
            );

            emitToasterMsg("success", "CER Report", "Claimed Successfully"
            );

            getCerWcnData();
        } catch (error) {
            console.error(error);
        }
    };

    const handleUnClaim = async (row) => {
        try {
            await unclaimReport(
                row.original.companyVerificationReportId,
            );

            emitToasterMsg("success", "CER Report", "Unclaimed Successfully"
            );

            getCerWcnData();
        } catch (error) {
            emitToasterMsg("error", "CER Report", "Unclaim failed"
            );
        }
    };

    const handleDelete = async () => {
        try {
            const isOnlyRecordOnPage = tableData.length === 1;
            await deleteReport(
                selectedRow.original.companyVerificationReportId
            );
            emitToasterMsg("success", "CER Report", "Deleted Successfully");
            setConfirmDelete(false);
            if (isOnlyRecordOnPage) {
            navigate(-1); // go back only when page becomes empty
        } else {
            getCerWcnData(); // stay on same page
        }
        } catch (error) {
            console.error(error);
        }
    };

    const handleDownloadBtnClick = async (row) => {
        try {
            const response = await downloadAllReportDocuments(
                row.original.companyVerificationReportId
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: "application/zip",
                })
            );

            const link = document.createElement("a");
            link.href = url;
            link.download = `VerificationDocuments_${row.original.companyVerificationReportId}.zip`;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
            emitToasterMsg("success", "", "The file downloaded Successfully");
            
        } catch (error) {
            console.error("Download failed", error);
            emitToasterMsg("Failed", "", "Download failed")
        }
    };

    const table = useMaterialReactTable({
		columns: [
			...CER_WCN_LISTING_TABLE_COLUMNS,
			{
				id: "actions",
				header: "",
				size: 50,
				enableColumnActions: false,
				enableColumnFilter: false,
				enableSorting: false,

                Cell: ({ row }) => {
                    const reviewerRole = user?.roles?.includes("ER_REVIEWER");
                    const verifierRole = user?.roles?.includes("ER_VERIFIER");
                    const superAdminRole = user?.roles?.includes("ER_SUPERADMIN");

                    const { show, disabled } = getDeleteState({
                                                reviewerRole,
                                                verifierRole,
                                                superAdminRole,
                                                status: row.original.status,
                                            });
                    return (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                            <Tooltip title="Download">
                                <Button
                                    outline={true}
                                    isIconOnly
                                    variant="tertiary"
                                    disabled={!row.original.isDocsAvaialble}
                                    onClick={(e) => {
                                        if (row.original?.isDocsAvaialble) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleDownloadBtnClick(row);
                                        }
                                    }}
                                >
                                    <Icon
                                        icon={ICONS.DOWNLOAD}
                                        className="d-flex"
                                        disabled={!row.original.isDocsAvaialble}
                                        outline={true}
                                        size="24px"
                                    />
                                </Button>
                            </Tooltip>

                            {show && (
                                <Tooltip title="Delete">
                                    <IconButton
                                        color="error"
                                        disabled={disabled}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedRow(row);
                                            setConfirmDelete(true);
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    );
                },
			},

			{
				accessorKey: "reviewer",
				header: "Latest Reviewer",

				Cell: ({ cell }) => <HighlightedCell value={cell.getValue()} columnId="Reviewer" reportListColumnFilters={pendingColumnFilters} user={user} />,

				Filter: () => (
					<MultiSelectFilter
						columnId="Reviewer"
						options={[
							...(user?.roles?.some((role) => role === "ER_REVIEWER" || role === "ER_SUPERADMIN") ? ["@Me"] : []),
							"@Unassigned",
							...engineersOptions,
						]}
						placeholder="Filter by Reviewer"
						columnWidth="300px"
						getFilterValue={getFilterValue}
						updateFilterValue={updateFilterValue}
					/>
				),
			},
			{
				accessorKey: "verifier",
				header: "Latest Verifier",

				Cell: ({ cell }) => <HighlightedCell value={cell.getValue()} columnId="Verifier" reportListColumnFilters={pendingColumnFilters} user={user} />,

				Filter: () => (
					<MultiSelectFilter
						columnId="Verifier"
						options={[
							...(user?.roles?.some((role) => role === "ER_VERIFIER" || role === "ER_SUPERADMIN") ? ["@Me"] : []),
							"@Unassigned",
							...engineersOptions,
						]}
						placeholder="Filter by Verifier"
						columnWidth="300px"
						getFilterValue={getFilterValue}
						updateFilterValue={updateFilterValue}
					/>
				),
			},
			{
				id: "assignActions",
				header: "",
				size: 120,
				enableColumnActions: false,
				enableColumnFilter: false,
				enableSorting: false,

				Cell: ({ row }) => {
					const reviewerRole = user?.roles?.includes("ER_REVIEWER");
					const verifierRole = user?.roles?.includes("ER_VERIFIER");
					const superAdminRole = user?.roles?.includes("ER_SUPERADMIN");

					const reportStatus = row.original.status;
					const reviewer = row.original.reviewer;

					const isReviewerUser = reviewerRole && !verifierRole && !superAdminRole;

					const isVerifierUser = verifierRole || superAdminRole;

					if (isReviewerUser) {
						const isMine = reviewer === user?.email;
						if (reportStatus === "Verification Completed" || reportStatus === "Verification In Progress") {
							return (
								<p>
									Claimed by <br />
									{reviewer}
								</p>
							);
						}
						if (reviewer && !isMine) {
							return <span style={{ fontSize: 12 }}>Claimed by {reviewer}</span>;
						}

						return (
							<Button
								size="small"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									isMine ? handleUnClaim(row) : handleClaim(row);
								}}
							>
								{reviewer ? "Unclaim" : "Claim"}
							</Button>
						);
					}

					if (isVerifierUser) {
						if (reportStatus === "Verification Completed") {
							return (
								<p>
									Claimed by <br />
									{reviewer}
								</p>
							);
						}
						return (
							<Button
								size="small"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									handleAssignClick(row);
								}}
							>
								{reviewer ? "Re-Assign" : "Assign"}
							</Button>
						);
					}
					return null;
				},
			},
		],
		data: tableData,
		enableStickyHeader: true,
		manualPagination: true,
		manualFiltering: true,
		manualSorting: true,
		enableFullScreenToggle: false,
		toggledensity: false,
		rowCount,
		enableExpandAll: false,
		enableExpanding: false,
		//enableBatchRowSelection: true,
		enableSorting: false,
		//filterFromLeafRows: true,
		enableTopToolbar: true,
		enableHiding: false,

		state: {
			pagination,
			columnFilters: pendingColumnFilters,
			//globalFilter: pendingGlobalFilter,
			globalFilter: pendingGlobalFilter,
			sorting,
			isLoading: loading,
		},
		onPaginationChange: setPagination,
		onColumnFiltersChange: (updater) => {
			const newFilters = typeof updater === "function" ? updater(pendingColumnFilters) : updater;

			setPendingColumnFilters(newFilters);

			if (newFilters.length === 0) {
				setColumnFilters([]);
				setPagination((prev) => ({
					...prev,
					pageIndex: 0,
				}));
			}
		},
		muiTableBodyRowProps: ({ row }) => ({
			sx: {
				cursor: "pointer",
			},
		}),

		onGlobalFilterChange: setPendingGlobalFilter,
		onSortingChange: setSorting,
		initialState: {
			density: "compact",
			columnOrder: ["actions", "cvrId", "modifiedDate", "dateOfIssuance", "status", "assignActions", "reviewer", "verifier"],
		},
		renderToolbarInternalActions: ({ table }) => (
			<>
				<MRT_ToggleGlobalFilterButton id="reports_view_global_search" table={table} />
				<MRT_ToggleFiltersButton id="reports_view_global_filter" table={table} />
				<Button className="ml-2" onClick={applyFilters}>
					Apply Filters
				</Button>
				<Button className="ml-2" variant="secondary" onClick={clearFilters}>
					Clear
				</Button>
			</>
		),
		muiFilterTextFieldProps: ({ column }) => ({
			onKeyDown: (e) => {
				if (e.key === "Enter") {
					applyFilters();
				}
			},
		}),
		muiSearchTextFieldProps: {
			onKeyDown: (e) => {
				if (e.key === "Enter") {
					applyFilters();
				}
			},
		},
        muiTableBodyCellProps: ({ row, row: { original }, column }) => ({
            component: CustomTableRow,
            ReportMstId: original.companyVerificationReportId,
            column: column,
            path: `/company-verification-report/${original.companyVerificationReportId}`,
            sx: {
					color: "black",
				},
            onClick: () => {
                navigate(`/company-verification-report/${original.companyVerificationReportId}`, {
                    state: { reportId: original.companyVerificationReportId },
                });
            },
        }),
	});

    return (
        <>
            <section className="p-4 cer-listing-container">
                <BreadCrumb items={breadcrumb} />
                 <h4 className="mb-3"><strong>{companyName} - {wcnNumber}</strong></h4>
                <MaterialReactTable table={table} />

                {showAssignModal && (
                    <div className="assign-modal">
                        <AbsModal
                            isOpen={showAssignModal}
                            title={"Assignment"}
                            onClose={setShowAssignModal}
                            close={toggleClose}
                        >
                            <div className="ml-3">
                                <h4 className="blod">Assignment</h4>
                                <hr />
                                <p>Please select an Engineer</p>
                                <hr />
                                <AutocompleteDropdown
                                    className="inputHeight"
                                    id="search-vessel-id"
                                    isClearable
                                    loadOptions={async (inputText) => {
                                        const options = await getAllEngineers(
                                            inputText
                                        );
                                        return options;
                                    }}
                                    placeholder={
                                        selectedEngineer || "Select an Engineer"
                                    }
                                    autoFocus={false}
                                    onChange={handleSelect}
                                    customStyles={{
                                        menuList: (provided) => ({
                                            ...provided,
                                        }),
                                    }}
                                />

                                <div className="d-flex justify-content-end mr-3 assignment-model-btns">
                                    <Button
                                        className="mr-3"
                                        id="assign-claim-btn-report-list"
                                        onClick={() => {
                                            handleAssign(
                                                selectedEngineer
                                            );
                                        }}
                                    >
                                        Assign/Reassign
                                    </Button>
                                    <Button
                                        id="cancel-btn-report-list"
                                        variant="secondary"
                                        onClick={() => {
                                            toggleClose();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </AbsModal>
                    </div>

                )}
                
                {confirmDelete && (
                    <div className="confirmation-modal-container">
                        <Modal
                            isOpen={confirmDelete}
                            modalHeader
                            padding={"70px"}
                            headerHeight={"50px"}
                            showFooter
                            onCloseClickListener={() => {
                                setConfirmDelete(false);
                            }}
                            footer={
                                <div className="d-flex justify-content-end fixed-action-btns p-4">
                                    <Button
                                        className="modal-delete-btn"
                                        onClick={() => handleDelete(selectedRow)}
                                        primaryColor={COLORS.RED.DARK}
                                        primaryBackgroundColor={COLORS.RED.LIGHT}
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="modal-cancel-btn"
                                        onClick={() => {
                                            setConfirmDelete(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            }
                        >
                            <div>Are you sure you want to delete this CER Report</div>
                        </Modal>
                    </div>
                )}
            </section>
        </>
    );
}
export default CERlisting;